export function loadHappygoOrderList(query) {
  return {
    type: 'LOAD_HAPPYGO_ORDER_LIST',
    query,
    willReload: !!query,
  };
}

export function loadHappygoOrderListCompletion(error, list) {
  return {
    type: 'LOAD_HAPPYGO_ORDER_LIST_COMPLETION',
    error,
    list,
  };
}

export function cancelHappygoOrder(orderId) {
  return {
    type: 'CANCEL_HAPPYGO_ORDER',
    orderId,
  };
}

export function cancelHappygoOrderCompletion(orderId, data, error) {
  return {
    type: 'CANCEL_HAPPYGO_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function refundHappygoOrder(orderId) {
  return {
    type: 'REFUND_HAPPYGO_ORDER',
    orderId,
  };
}

export function refundHappygoOrderCompletion(orderId, data, error) {
  return {
    type: 'REFUND_HAPPYGO_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function loadHappygoOrder(orderId) {
  return {
    type: 'LOAD_HAPPYGO_ORDER',
    orderId,
  };
}

export function loadHappygoOrderCompletion(orderId, data, error) {
  return {
    type: 'LOAD_HAPPYGO_ORDER_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function preCreateHappygoOrder(selectedList = []) {
  return {
    type: 'PRE_CREATE_HAPPYGO_ORDER',
    selectedList,
  };
}

export function preCreateHappygoOrderCompletion(error, data, selectedList) {
  return {
    type: 'PRE_CREATE_HAPPYGO_ORDER_COMPLETION',
    error,
    data,
    selectedList,
  };
}

export function createHappygoOrder() {
  return {
    type: 'CREATE_HAPPYGO_ORDER',
  };
}

export function createHappygoOrderCompletion(error, data) {
  return {
    type: 'CREATE_HAPPYGO_ORDER_COMPLETION',
    data,
    error,
  };
}

export function resetHappygoOrderInfo() {
  return {
    type: 'RESET_HAPPYGO_ORDER_INFO',
  };
}

export function payHappygoOrderByWechat(orderId) {
  return {
    type: 'PAY_HAPPYGO_ORDER_BY_WECHAT',
    orderId,
  };
}

export function payHappygoOrderByWechatCompltion(orderId, error, data) {
  return {
    type: 'PAY_HAPPYGO_ORDER_BY_WECHAT_COMPLETION',
    orderId,
    data,
    error,
  };
}

export function loadHappygoOrderTrack(expressNo) {
  return {
    type: 'LOAD_HAPPYGO_ORDER_TRACK',
    expressNo,
  };
}

export function loadHappygoOrderTrackCompletion(expressNo, error, data) {
  return {
    type: 'LOAD_HAPPYGO_ORDER_TRACK_COMPLETION',
    expressNo,
    data,
    error,
  };
}
